import React from 'react';
import { BethEarnestLayout } from '../layouts/BethEarnestLayout';
import { PaymentTypeHeader } from 'src/components/payment-type/PaymentTypeHeader';
import { PaymentTypeSelection } from 'src/components/payment-type/PaymentTypeSelection';
import { useTransactionInformation } from 'src/store/useTransactionInformation';
import { Button } from '@zillow/constellation-10';
import { useRouter } from 'next/router';
import { ePages } from 'src/utilities/ePages';
import { useAccessCodeFromQueryString } from 'src/components/transaction-input/useAccessCodeFromQueryString';
import { AccessCodeInfoBlock } from 'src/components/layout/AccessCodeInfoBlock';
import { StateInfoBlock } from 'src/components/layout/StateInfoBlock';

const PaymentType: React.FC = () => {
  useAccessCodeFromQueryString();

  return (
    <BethEarnestLayout
      infoBlock={
        <>
          <AccessCodeInfoBlock />
          <StateInfoBlock />
        </>
      }
      showFooter={false}
    >
      <main>
        <PaymentTypeHeader />
        <PaymentTypeSelection />
      </main>
    </BethEarnestLayout>
  );
};

export default PaymentType;
